import React, { useRef } from "react";
import "../../css/components/controls/HrnbSlider.css";

export default function HrnbSlider({
                                       label,
                                       min = 0,
                                       max = 100,
                                       step = 1,
                                       value,
                                       onChange,
                                       disabled = false,
                                       className = "",
                                       hint = "",
                                       error = "",
                                       showValue = true,
                                       ...props
                                   }) {
    const inputRef = useRef();

    const handleChange = (e) => {
        if (onChange) onChange(Number(e.target.value));
    };

    return (
        <div className={`hrnb-slider-wrap ${className} ${disabled ? "hrnb-slider--disabled" : ""}`}>
            {label && (
                <label className="hrnb-slider__label" htmlFor={props.id}>
                    {label}
                    {showValue && (
                        <span className="hrnb-slider__value">{value}</span>
                    )}
                </label>
            )}
            <input
                ref={inputRef}
                type="range"
                min={min}
                max={max}
                step={step}
                value={value}
                onChange={handleChange}
                disabled={disabled}
                className={`hrnb-slider__input${error ? " hrnb-slider__input--error" : ""}`}
                id={props.id}
                {...props}
            />
            <div className="hrnb-slider__scale">
                <span>{min}</span>
                <span>{max}</span>
            </div>
            {error
                ? <div className="hrnb-slider__error">{error}</div>
                : hint && <div className="hrnb-slider__hint">{hint}</div>
            }
        </div>
    );
}
